import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import { AccommodationPolicyDescription } from 'components/AccommodationKit/AccommodationAmenitiesAndPoliciesContent'

type Props = {
  policyDescription: string
}

function PackageInclusionsPolicyModal({ policyDescription }: Props) {
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'N6arZApCCHoo42xME1Iw',
        defaultMessage: 'Guest Policy',
      })}
    >
      <AccommodationPolicyDescription policyDescription={policyDescription} />
    </Modal>
  )
}

export default PackageInclusionsPolicyModal
